/**
 * Drafts the assistant's builder is writing right now. The build opens the
 * tab as it starts (`building: true`) and again when it lands; a failed build
 * has no second open, so the turn ending clears everything too.
 */
import { useSyncExternalStore } from "react";

const building = new Set<string>();
const listeners = new Set<() => void>();
let snapshot: ReadonlySet<string> = new Set();

const publish = () => {
  snapshot = new Set(building);
  listeners.forEach((fn) => fn());
};

export const markBuilding = (intakeId: string, on: boolean) => {
  if (on === building.has(intakeId)) return;
  if (on) building.add(intakeId);
  else building.delete(intakeId);
  publish();
};

export const clearBuilding = () => {
  if (!building.size) return;
  building.clear();
  publish();
};

const subscribe = (fn: () => void) => {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
};

export const useIsBuilding = (intakeId: string): boolean =>
  useSyncExternalStore(subscribe, () => snapshot).has(intakeId);
